module.exports = __webpack_public_path__ + "img/ic_module_item_img4.612f5db7.png";